'use strict';

var footerFindStore = require('./footerFindStore');
var LocationSearch = require('../../../../app_storefront_core/cartridge/js/bopis/components/LocationSearch');
var SiteConstants =require('../../../../bc_sheplersbootbarn_core/cartridge/js/SiteConstants');
var page = require('../../../../app_storefront_core/cartridge/js/page');

var isMobileNavRedesign;
var locationSearchMobileNavigation;
var siteName;

var bootbarnApp = {
    init: function () {
		$.extend(page, window.pageContext);

		locationSearchMobileNavigation = new LocationSearch();
		siteName = pageContext && pageContext.site ? pageContext.site : '';
		footerFindStore.init();

		$(document).on('click', '.my-store-panel .store-view', function(event) {
			if (siteName == SiteConstants.SiteIds.BootBarnUS && SitePreferences.MOBILE_NAV_REDESIGN == 'redesign' && window.innerWidth <= 1024) {
				var storeId = $('.map.store').attr('data-id');
				var $storeLocation = $(this).closest('.store-location');
				$(document).trigger('Mobile.Redesign.Reset'); // Close other open menu drawers
				if (!$storeLocation.find('.selected-store-container .store-information').length || $storeLocation.find('.selected-store-container .store-information').is(':empty')) {
					locationSearchMobileNavigation.updateStoreDetails(storeId);
				}
				$storeLocation.addClass('store-location-drawer-open').find('.selected-store-container').stop().animate({ left: '0px' }, 'fast');
				$(document).trigger('Mobile.Redesign.AutoScroll');
			} else {
				$('.my-store-modal').show();
			}
		});

		$(document).on('click', '.my-store-modal .close', function(event) {
			$('.my-store-modal').hide();
		});

		$(document).on('click', '.shop-my-store .show-store-search, .my-store-panel .show-store-search:not(.nav-rd-mobile *), .my-store-modal .show-store-search:not(.nav-rd-mobile *)', function(event) {
			$('.my-store-modal').hide();
			locationSearchMobileNavigation.initialize($('.location-search-dialog').not('.stores-content-container .location-search-dialog'), $.extend(page.options.Bopis, { Channel: page.options.Channel }));
		});

		$(document).on('click', '.nav-rd-mobile .my-store-panel .show-store-search, .nav-rd-mobile .my-store-modal .show-store-search', function(event) {
			if (siteName == SiteConstants.SiteIds.BootBarnUS && SitePreferences.MOBILE_NAV_REDESIGN == 'redesign' && window.innerWidth <= 1024) {
				var $storeLocation = $(this).closest('.store-location');
				$(document).trigger('Mobile.Redesign.Reset'); // Close other open menu drawers
				$storeLocation.addClass('store-location-drawer-open').find('.stores-content-container').stop().animate({ left: '0px' }, 'fast');
				locationSearchMobileNavigation.initialize($('.stores-content-container .location-search-dialog'), $.extend(page.options.Bopis, { Channel: page.options.Channel }));
				if (!$storeLocation.find('.stores-content-container .result').length || $storeLocation.find('.stores-content-container .result').is(':empty')) {
					locationSearchMobileNavigation.$container.trigger('LocationSearch.GeolocationSearch');
				}
				$(document).trigger('Mobile.Redesign.AutoScroll');
			}
		});

		/* -- 2025 Nav Redesign -- */
		isMobileNavRedesign = siteName == SiteConstants.SiteIds.BootBarnUS && SitePreferences.MOBILE_NAV_REDESIGN == 'redesign' && window.innerWidth <= 1024;

		$(document).off('Mobile.Redesign.AutoScroll').on('Mobile.Redesign.AutoScroll', function (event) {
			$('.rd-nav-top-banner').animate({
				scrollTop: 0
			}, 'slow');
		});

		$(document).off('Mobile.Redesign.Reset').on('Mobile.Redesign.Reset', function (event, closeDrawer) {
			if (isMobileNavRedesign) {
				var $newMobileMenu = $('.nav-rd-mobile');
				$newMobileMenu.find('.submenu-active, .stores-drawer').css('left', '-100%');
				$newMobileMenu.find('.submenu-active, .accordion-content').hide();
				$newMobileMenu.find('.has-dropdown.active, .submenu-active, .accordion-open').removeClass('active submenu-active accordion-open');
				if (closeDrawer) {
					$('.rd-nav-top-banner .drawer-open').removeClass('drawer-open');
				}
				$('html').removeClass('scroll-lock');
			}
		});

		$(document).off('Mobile.Redesign.SetStore').on('Mobile.Redesign.SetStore', function (event) {
			if (isMobileNavRedesign) {
				$('.selected-store-container').stop().animate({ left: '0px' }, 'fast');
				$(document).trigger('Mobile.Redesign.AutoScroll');
			}
		});

		$(document).off('Mobile.Redesign.ToggleEllipsis').on('Mobile.Redesign.ToggleEllipsis', function (event) {
			if (isMobileNavRedesign) {
				var $storePanel = $('.rd-menu-utility .store-location .my-store-panel');
				var $storeName = $('.store-view-populated .store-name');
				if ($storePanel.length && $storeName.length) {
					if ($storeName.height() <= 15) {
						$storePanel.removeClass('add-ellipsis');
					} else {
						$storePanel.addClass('add-ellipsis');
					}
				}
			}
		});
		/* -- END: 2025 Nav Redesign -- */

		$(document).off('Bopis.SelectedStore.Refresh').on('Bopis.SelectedStore.Refresh', function (event, storeId) {
			locationSearchMobileNavigation.updateStoreDetails(storeId);
		});

		$(document).off('Bopis.AssignStoreToProfile').on('Bopis.AssignStoreToProfile', function (event, storeId) {
			locationSearchMobileNavigation.assignStoreId(storeId);
		});

		$(document).on('click', '.shop-my-store .show-my-store-modal', function(event) {
			$('.my-store-modal').show();
		});

    }
};

//initialize app
$(document).ready(function () {
	bootbarnApp.init();
});